<template>
    <div class="home-manage">
      <div style="padding: 20px">
        <div class="home-page-pics-mange">
          <div class="title">首页广告轮播图管理</div>
          <div>
            <div style="margin-top: 10px">
              <el-button type="primary" size="small" icon="el-icon-plus"
                         :disabled="advantageArr.length >= 4"
                         :title="(advantageArr.length >= 4 ? '最多支持4个轮播广告！' : '')"
                         @click="showAddPicDrawer()">添加</el-button>
            </div>
            <div class="advantage-item" v-for="(item, index) of advantageArr" :key="index">
              <el-card :body-style="{ padding: '0px' }">
                <!--suppress HtmlUnknownTarget -->
                <img :src="item.picUrl" class="advantage-item-pic" :alt="item['advertisementName']">
                <div style="padding: 14px;">
                  <span>{{item.advertisementName}}</span>
                  <div class="bottom clearfix">
                    <time class="time">更新时间：{{ item['updateTime'] | dateFormat("YYYY-MM-DD HH:mm:ss") }}</time>
                    <el-button type="text" class="button" @click="showAddPicDrawer(item)">编辑</el-button>
                    <el-button type="text" class="button" @click="deleteAdvantage(item)">删除</el-button>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
          <el-drawer
            :visible.sync="drawer1"
            :append-to-body="true"
            :title="drawer1Title"
            :before-close="handleClose1">
            <div class="edit-advantage-info-drawer">
              <el-form label-width="100px" :model="advantage" ref="advEditForm">
                <el-form-item label="广告名称：" prop="title">
                  <el-input v-model="advantage.advertisementName" placeholder="请填写广告名称"></el-input>
                </el-form-item>
                <el-form-item label="广告图片：" prop="documentId">
                  <div v-if="advantageEditFlag && showAdvantageImg" class="img-edit-view-content">
                    <div class="hide-img-bk">
                      <i class="hide-img el-icon-delete" title="删除" @click="editAdvertiseRemovePic()"></i>
                    </div>
                    <img class="img-edit-view" :src="advantage.picUrl" />
                  </div>
                  <el-upload
                    ref="upload"
                    :action="ID_CARD_URI"
                    :headers="{'auth-user': $store.get('Authorization')}"
                    :data="{isImage: true}"
                    list-type="picture-card"
                    :on-preview="handlePreview"
                    :on-success="handleSuccess1"
                    :accept="'.jpg,.png'"
                    :limit="1"
                    :on-remove="handleRemove1">
                    <div slot="tip" class="upload-mask">只能上传jpg/png文件，且不超过500M</div>
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-form>

              <div class="btn-group">
                <el-button size="small" type="primary" @click="submitForAdvantage()">保存</el-button>
                <el-button size="small" @click="drawer1 = false">取消</el-button>
              </div>
            </div>
          </el-drawer>

          <el-dialog :visible.sync="picDialogVisible" :width="'600px'">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </div>

        <div class="home-page-tips-mange" style="margin-top: 20px">
          <div class="title">首页公告栏管理</div>
          <div><div style="margin: 10px 0">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="editTip()">添加</el-button>
            <el-button type="primary" size="small" icon="el-icon-delete" @click="batchDeleteNotices()">批量删除</el-button>
          </div>
            <el-table
              ref="multipleTable"
              width="100%"
              border
              maxHeight="600"
              :data="tipsArr"
              @selection-change="handleSelectionChange"
              tooltip-effect="dark">
              <el-table-column
                type="selection"
                width="40">
              </el-table-column>
              <el-table-column
                fixed="left"
                prop="noticeContent"
                :show-overflow-tooltip="true"
                label="公告内容"
                width="">
              </el-table-column>
              <el-table-column
                prop="createDate"
                :show-overflow-tooltip="true"
                label="创建时间"
                width="160">
                <template slot-scope="scope">
                  <span>
                    {{scope.row.createDate | dateFormat("YYYY-MM-DD HH:mm:ss")}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="left"
                prop="updateDate"
                :show-overflow-tooltip="true"
                label="更新时间"
                width="160">
                <template slot-scope="scope">
                  <span>
                    {{scope.row.updateDate | dateFormat("YYYY-MM-DD HH:mm:ss")}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="desiredPosition"
                label="操作"
                width="130">
                <template slot-scope="scope">
                  <span>
                    <el-button type="text" class="button" @click="editTip(scope.row)">编辑</el-button>
                    <el-button type="text" class="button" @click="deleteTip(scope.row)">删除</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-content" v-if="tipsArr.length > 0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.pageNum"
                :page-sizes="[20, 50, 100]"
                :page-size="20"
                layout="total, sizes, prev, pager, next, jumper"
                :total="page.total">
              </el-pagination>
            </div>
          </div>
          <el-drawer
            :visible.sync="drawer2"
            :append-to-body="true"
            :title="drawer2Title"
            :before-close="handleClose1">
            <div class="edit-advantage-info-drawer">
              <el-form label-width="100px" :model="tip" ref="advTipForm">
                <el-form-item label="公告内容：" prop="noticeContent">
                  <el-input type="textarea" :autosize="{minRows: 3}" v-model="tip.noticeContent" placeholder="请填写公告信息"></el-input>
                </el-form-item>
              </el-form>

              <div class="btn-group">
                <el-button size="small" type="primary" @click="submitForTip()">保存</el-button>
                <el-button size="small" @click="drawer2 = false">取消</el-button>
              </div>
            </div>
          </el-drawer>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'HomeManage',
  data () {
    return {
      ID_CARD_URI: location.origin + '/recurit/document/upload/idCard?category=ADVERTISEMENT',
      picDialogVisible: false,
      dialogImageUrl: '',
      drawer1: false,
      drawer1Title: '添加广告信息',
      advantage: {},
      advantageEditFlag: false,
      showAdvantageImg: false,
      advantageArr: [],
      drawer2: false,
      drawer2Title: '添加公告信息',
      tip: {},
      tipEditFlag: false,
      tipsArr: [],
      selectedNotices: [],
      locationOrigin: location.origin,
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  methods: {
    showAddPicDrawer (advantage) {
      this.advantage = Object.assign({}, advantage)
      this.advantageEditFlag = !!advantage
      this.showAdvantageImg = !!advantage
      this.drawer1Title = this.advantageEditFlag ? '修改广告信息' : '添加广告信息'
      this.drawer1 = true
    },
    editAdvertiseRemovePic () {
      this.showAdvantageImg = false
    },
    handleClose1 (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.advantage = {}
          this.tip = {}
          this.$refs.upload.clearFiles()
          done()
        })
        .catch(_ => {})
    },
    submitForAdvantage () {
      if (this.advantageEditFlag) {
        // 编辑接口
        let documentId = this.advantage.documentId
        documentId = (!!documentId && documentId !== this.advantage['advertisementImage']['id']) ? documentId : this.advantage['advertisementImage']['id']
        let param = {
          id: this.advantage.id,
          advertisementName: this.advantage.advertisementName,
          documentId
        }
        this.$confirm('确认修改该条广告么？')
          .then(_ => {
            this.$http.put(this.$api.updateAdvertisement.url, param).then(_ => {
              if (_ && _.code === 200) {
                this.drawer1 = false
                this.showAdvantageImg = false
                this.initGetAdvertisements()
                this.$message.success(' 广告修改成功！')
              } else {
                this.$message.error(_.msg)
              }
            })
          })
          .catch(_ => {})
      } else {
        // 新增接口
        let param = {
          advertisementName: this.advantage.advertisementName,
          documentId: this.advantage.documentId
        }
        this.$http.post(this.$api.addAdvertisement.url, param).then(_ => {
          if (_ && _.code === 200) {
            this.advantage = {}
            this.drawer1 = false
            this.initGetAdvertisements()
            this.$message.success('广告添加成功！')
          } else {
            this.$message.error(_.msg)
          }
        })
      }
    },
    deleteAdvantage (item) {
      this.$confirm('确认删除该条广告么？')
        .then(_ => {
          this.$http.delete(this.$api.batchDeleteAdvertisement.url, null, {data: [item.id]}).then(_ => {
            if (_ && _.code === 200) {
              this.initGetAdvertisements()
              this.$message.success(' 广告删除成功！')
            } else {
              this.$message.error(_.msg)
            }
          })
        })
        .catch(_ => {})
    },
    editTip (tip) {
      this.tip = Object.assign({}, tip)
      this.tipEditFlag = !!tip
      this.drawer2Title = this.tipEditFlag ? '修改公告信息' : '添加公告信息'
      this.drawer2 = true
    },
    handleSelectionChange (val) {
      this.selectedNotices = val
    },
    submitForTip () {
      if (this.tipEditFlag) {
        // 编辑接口
        let param = {
          id: this.tip.id,
          noticeContent: this.tip.noticeContent
        }
        this.$http.put(this.$api.updateNotice.url, param).then(_ => {
          if (_ && _.code === 200) {
            this.initGetNotices()
            this.drawer2 = false
            this.$message.success(' 公告修改成功！')
          } else {
            this.$message.error(_.msg)
          }
        })
      } else {
        // 新增接口
        let param = {noticeContent: this.tip.noticeContent}
        this.$http.post(this.$api.addNotice.url, param).then(_ => {
          if (_ && _.code === 200) {
            this.initGetNotices()
            this.drawer2 = false
            this.$message.success(' 公告新增成功！')
          } else {
            this.$message.error(_.msg)
          }
        })
      }
    },
    deleteTip (item) {
      this.$confirm('确认删除该条公告么？')
        .then(_ => {
          this.$http.delete(this.$api.deleteNotice.url, null, {data: [item.id]}).then(_ => {
            if (_ && _.code === 200) {
              this.initGetNotices()
              this.$message.success(' 公告删除成功！')
            } else {
              this.$message.error(_.msg)
            }
          })
        })
        .catch(_ => {})
    },
    batchDeleteNotices () {
      if (this.selectedNotices.length === 0) {
        this.$message.warning('请至少选择一条公告进行删除！')
      } else {
        let ids = this.selectedNotices.map(item => item.id)
        this.$confirm(`确认删除选中的${ids.length}条公告么？`)
          .then(_ => {
            this.$http.delete(this.$api.deleteNotice.url, null, {data: ids}).then(_ => {
              if (_ && _.code === 200) {
                this.initGetNotices()
                this.$message.success(' 公告删除成功！')
              } else {
                this.$message.error(_.msg)
              }
            })
          })
          .catch(_ => {})
      }
    },
    initGetAdvertisements () {
      this.$http.get(`${this.$api.getAdvertisements.url}?pageNum=${1}&pageSize=${4}`, {}).then(_ => {
        if (_ && _.code === 200) {
          this.advantageArr = (_.data.list || []).map(item => {
            let picUrl = `${this.locationOrigin}/${item['advertisementImage']['url']}/${item['advertisementImage']['documentName']}.${item['advertisementImage']['suffix']}`
            return Object.assign(item, {picUrl})
          })
        }
      })
    },
    initGetNotices () {
      this.$http.get(`${this.$api.getNotices.url}?pageNum=${this.page.pageNum}&pageSize=${this.page.pageSize}`).then(_ => {
        if (_ && _.code === 200 && _.data && _.data.list) {
          this.tipsArr = _.data.list || []
          this.page.pageSize = _.data.pageSize || this.page.pageSize
          this.page.pageNum = _.data.pageNum || this.page.pageNum
          this.page.total = _.data.total || this.page.total
        }
      })
    },
    handleCurrentChange (val) {
      console.log(val)
      this.page.pageNum = val
      this.initGetNotices()
    },
    handleSizeChange (val) {
      console.log(val)
      this.page.pageSize = val
      this.initGetNotices()
    },
    handlePreview (file) {
      this.dialogImageUrl = file.url
      this.picDialogVisible = true
    },
    handleSuccess1 (response, file, fileList) {
      console.log(response)
      if (response.code === 200 && response.data) {
        this.advantage.documentId = response.data.id
      }
    },
    handleRemove1 (file, fileList) {
      this.advantage.documentId = ''
      if (this.advantageEditFlag) {
        this.showAdvantageImg = true
      }
    }
  },
  mounted () {
    this.initGetAdvertisements()
    this.initGetNotices()
    if (location.origin.includes('127.0.0.1') || location.origin.includes('localhost')) {
      this.ID_CARD_URI = location.origin + '/api/recurit/document/upload/idCard?category=ADVERTISEMENT'
      this.locationOrigin = 'http://134.175.126.154:8080'
    }
  }
}
</script>

<style scoped>
  .home-manage {
    width: 1200px;
    margin: auto;
    text-align: left;
    min-height: calc(100vh - 200px);
    background: #ffffff;
  }
  .title {
    position: relative;
    font-size: 16px;
    font-weight: bold;
  }
  .title::before {
    position: absolute;
    content: '';
    border-left: 3px solid #39f;
    height: 16px;
    top: 3px;
    left: -8px;
  }
  .advantage-item {
    width: 30%;
    height: 100px;
    display: inline-block;
    margin: 10px 10px 10px 0;
  }
  .advantage-item-pic {
    width: 100%;
    height: 200px;
  }
  .edit-advantage-info-drawer {
    width: 100%;
    height: 100%;
    padding: 20px;
  }

  /*noinspection CssUnusedSymbol*/
  /deep/ .el-drawer__header {
    margin-bottom: 0;
  }
  /deep/ .el-drawer__header>:first-child {
    font-size: 16px;
    outline: none;
    position: relative;
  }
  /deep/ .el-drawer__header>:first-child::before {
    position: absolute;
    content: '';
    width: 4px;
    height: 24px;
    background: #409EFF;
    left: -20px;
  }

  /*noinspection CssUnusedSymbol*/
  /deep/ .el-drawer__body {
    /*noinspection CssInvalidPropertyValue*/
    overflow: overlay;
  }
  /deep/ .btn-group {
    position: absolute;
    bottom: 0;
    margin-bottom: 20px;
  }
  .pagination-content {
    margin-top: 15px;
    text-align: right;
  }
  .upload-mask {
    color: #fd5f39;
    position: absolute;
    height: 200px;
    background: #ffffff;
    top: 150px;
  }
  .img-edit-view {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    border: 1px dashed #ccc;
  }
  .img-edit-view-content {
    position: absolute;
  }
  .hide-img {
    color: #cccccc;
    font-size: 16px;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
  .hide-img-bk {
    position: absolute;
    width: 152px;
    height: 150px;
    z-index: 9;
    border-radius: 5px;
  }
  .hide-img-bk:hover {
    background: rgba(000,000,000, .3);
  }
  .hide-img-bk:hover .hide-img {
    color: #ffffff;
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeManage/HomeManage.vue